import { TemplateConfig } from '../types';

export const peachBlossomSpreadConfig: TemplateConfig = {
  id: 'peach-blossom-spread',
  name: '桃花牌阵',
  description: '分析我未来三个月的桃花',
  cardCount: 6,
  
  fieldDefaults: {
    title: '桃花牌阵',
    customerQuestion: '**分析我未来三个月内的桃花状况，接下来的新桃花的对象的各方面情况，以及我和未来的对方的感情走向。**',
    cardPlaceholders: [
      '请输入第 1 行第 1 张牌',
      '请输入第 2 行第 1 张牌',
      '请输入第 2 行第 2 张牌',
      '请输入第 3 行第 1 张牌',
      '请输入第 3 行第 2 张牌',
      '请输入第 3 行第 3 张牌'
    ],
    cardInfos: [
      '未来三个月内的桃花状况',
      '你接下来一段新桃花中，对方的星座，需要明确指出可能的星座类型，并给出具体星座示例，比如火象星座就写比如白羊座、狮子座、射手座',
      '你接下来一段新桃花中，对方的外貌特征，要具体描述肤色、身高、脸型、穿搭风格、眼神等细节，比如肤色偏白、身高175左右、瓜子脸、穿搭风格简约得体、眼睛明亮有神',
      '你和接下来的新桃花的感情的持续时间',
      '你和接下来的新桃花在感情中会遇到的问题',
      '你和接下来的新桃花在感情中的发展趋势'
    ]
  },
  
  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],
  
  generateOptions: {
    normal: true,
    thinking: true
  },
  
  ui: {
    color: '#eb2f96',
    backgroundColor: '#fff0f6',
    icon: '🌸'
  }
};

